module.exports = __webpack_public_path__ + "assets/img/eleven04.3df475f1.png";